<section class="container" *ngIf="data?.action === 'videoThumbnailPop'">
	<div>
		<div class="close-icon cursor-pointer" (click)="dialogRef.close()">
			<mat-icon matRipple>close</mat-icon>
		</div>
	</div>
	<div class="cover-image-popup">
		<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
			<div fxLayout="row" fxLayoutAlign="center center" class="video-thumbnail">
				<video fxFlex="540px" fxFlex.xs="100" autoplay [muted]="true" [src]="videoSrc" #videoFile
					[controls]="showFrame =='frame'" disablePictureInPicture
					controlsList="nodownload nofullscreen noplay"></video>
				<ng-container *ngIf="showFrame =='cover'">
					<!-- <video [src]="videoSrc" ></video> -->
					<div class="video-controls" fxLayout="row" fxLayoutAlign="center center">
						<mat-icon class="left" svgIcon="back" (click)="jumpDuration(videoFile,'previous')"></mat-icon>
						<mat-icon class="play" svgIcon="play" (click)="playVideo(videoFile)"></mat-icon>
						<mat-icon class="right" svgIcon="next" (click)="jumpDuration(videoFile,'forward')"></mat-icon>
					</div>
				</ng-container>
			</div>
			<ng-container *ngIf="showFrame =='frame'">
				<button (click)="selectFrame(videoFile)" mat-stroked-button class="select-frame-btn" type="button">
					{{locale.translate('select_current_frame')}}
				</button>
			</ng-container>
			<ng-container *ngIf="showFrame =='cover'">
				<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px" class="arrow-control-help-text">
					<div class="arrow-help-text">{{locale.translate('frame_selection')}}</div>
					<button (click)="setThumbnail(videoFile)" mat-stroked-button class="cover-image-btn" type="button"
						appAutoFocus>
						{{locale.translate('set_cover_image')}}
					</button>
				</div>
			</ng-container>
		</div>
	</div>
</section>
